<div class="flex justify-end overflow-hidden items-center relative w-full h-full min-h-screen foreground">
  <img class="absolute z-10 top-4 left-4 mx-auto max-w-40 w-full h-auto" alt="logo" width="887" height="459" [ngSrc]="'assets/images/logo.png'">
  <img priority class="absolute z-0 -bottom-2/4 lg:-bottom-40 lg:-left-40 w-full h-full object-cover" alt="login" width="3000" height="2000" [ngSrc]="'assets/images/login.png'">

  <form class="w-full max-w-md lg:w-1/3 z-10 p-4 lg:mx-28 bg-neutral-white/40 border-radius"
        [formGroup]="form"
        (submit)="submit()"
  >
    <h3
      class="text-color text-balance text-end bg-lGray950 dark:bg-lBlue800 py-1 pr-2 text-3xl font-bold leading-9"
    >
      Preencha sua nova senha
    </h3>
    <p class="subtext-color text-balance text-end mt-1 leading-6">
      Muito bem, defina sua nova senha.
    </p>

    <div class="mt-8">
      <label class="subtext-color text-sm" for="password">Senha</label>
      <input [lDisabled]="isLoading" disableType="full" class="mt-2" type="password" autocomplete="new-password" formControlName="password" id="password" lInput />
    </div>

    <div class="mt-4">
      <label class="subtext-color text-sm" for="password">Confirmar Senha</label>
      <input [lDisabled]="isLoading" disableType="full" class="mt-2" type="password" autocomplete="new-password" formControlName="confirmPassword" id="confirm-password" lInput />
    </div>

    <div class="flex flex-col mt-8">
      <button [lDisabled]="isLoading" disableType="no-visual" class="relative" lButton bType="primary" type="submit">
        <div *ngIf="isLoading" class="flex items-center absolute left-1/3">
          <l-icon class="text-xl text-lWhite animate-spin">progress_activity</l-icon>
        </div>

        Confirmar
      </button>

      <a routerLink="/login" class="no-underline subtext-color text-sm mt-4 mx-auto">voltar</a>
    </div>
  </form>
</div>
